import { render, staticRenderFns } from "./SysNcConfigManager.vue?vue&type=template&id=913fa71a&scoped=true&"
import script from "./SysNcConfigManager.vue?vue&type=script&lang=js&"
export * from "./SysNcConfigManager.vue?vue&type=script&lang=js&"
import style0 from "./SysNcConfigManager.vue?vue&type=style&index=0&id=913fa71a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913fa71a",
  null
  
)

export default component.exports